export enum StoreStatusEnum {
    Open = 0,
    Rest = 1,
    Close = 2,
    Address = 3,
    Build = 4,
}
